import { render } from "./App.vue?vue&type=template&id=382a9713"
const script = {}

import exportComponent from "/Users/seoromalgm/Desktop/dev/dev_2022/aromatica-evt-quiz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__